import React, { PureComponent, Fragment } from 'react';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { Card, CardBody, Col, Row, Container, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import {
  isMobile,
} from "react-device-detect";
import TablePagination from '@material-ui/core/TablePagination';
import ExpiredListingsListTable from './ExpiredListingsListTable';
import SaveAlertModal from './SaveAlertModal';
import BellPlusIcon from 'mdi-react/BellPlusOutlineIcon';
import LinearLoading from '../../../shared/components/LinearLoading';
import BuildingSearchAppBar from '../../../shared/components/building_filters/UnitsSearchAppBar';
import ToggleChips from '../../OwnerOutreach/components/ToggleChips';
import OwnerListButton from '../../../shared/components/data_export/OwnerListButton';
import BulkSkipTraceModal from '../../../shared/components/skiptrace/BulkSkipTraceModal';
import Fab from '@material-ui/core/Fab';
import ContactPhoneIcon from 'mdi-react/ContactPhoneIcon';
import { Tooltip } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import moment from "moment";

import { _axiosCall } from '../../../shared/helpers/apicalls';
import {
	_formatNumber,
	_formatPrice,
	_nameToUrl,
	_getBuildingURL,
	buildingFL,
	_isEqual,
	syncURLFilters,
	syncURLSearch,
	setURLFromState,
	setLocalStorage,
	deleteLocalStorage,
	syncStageFilters,
	syncGenericFilter,
	_objectEqual,
	propertyExportFL,
	getCohortQuery,
	propertyExportFLRestricted,
	_validUnitSources,
	mailingListFL,
	_isHouse,
	expiredListingsFL
} from "../../../shared/helpers/utils";
import {
	_expiredListingsFilters,
	_onMarketListingsFilters,
	_buildingStageFilter,
	_unitStageFilter
} from "../../../shared/helpers/filters";
import { buildExpiredListingsQuery, getExpiredListingsBaseFQ } from "../../../shared/helpers/expiredListingsQuery";
import EnterpriseGate from '../../../shared/components/payment/EnterpriseGate';
import { _hasPermission } from "../../../shared/helpers/access";

const buildingUrl = process.env.API_ROOT + '/query/';

// Expired listings specific chip data
const expiredListingsChipData = [
	{
		key: "past_week",
		label: "Past Week",
		filter: { min_off_market_date: moment().subtract(1, 'weeks').format("YYYY-MM-DD"), max_off_market_date: moment().format("YYYY-MM-DD") }
	},
	{
		key: "past_month",
		label: "Past Month",
		filter: { min_off_market_date: moment().subtract(1, 'months').format("YYYY-MM-DD"), max_off_market_date: moment().format("YYYY-MM-DD") }
	},
	{
		key: "tom_listings",
		label: "Temporarily Off Market",
		filter: { off_market_type: ["tom"] },
		multiSelect: true
	},
	{
		key: "pom_listings",
		label: "Permanently Off Market",
		filter: { off_market_type: ["pom"] },
		multiSelect: true
	},
	{
		key: "expired_listings",
		label: "Expired Listings",
		filter: { off_market_type: ["expired"] },
		multiSelect: true
	}
];

const onMarketChipData = [
	{
		key: "dom_30_plus",
		label: "On Market 30+ Days",
		filter: { min_dom_on_market: 30 }
	},
	{
		key: "dom_60_plus",
		label: "On Market 60+ Days",
		filter: { min_dom_on_market: 60 }
	},
	{
		key: "dom_90_plus",
		label: "On Market 90+ Days",
		filter: { min_dom_on_market: 90 }
	},
	{
		key: "dom_120_plus",
		label: "On Market 120+ Days",
		filter: { min_dom_on_market: 120 }
	},
	{
		key: "dom_180_plus",
		label: "On Market 180+ Days",
		filter: { min_dom_on_market: 180 }
	},
	{
		key: "dom_270_plus",
		label: "On Market 270+ Days",
		filter: { min_dom_on_market: 270 }
	},
	{
		key: "dom_360_plus",
		label: "On Market 360+ Days",
		filter: { min_dom_on_market: 360 }
	}
];

let lsPre = "EL_";
const subFilterKey = 'subFilters';
const unitStagesKey = 'unitStages';
const buildingStagesKey = 'buildingStages';
const searchModeKey = 'searchMode';
const defaultSubFilter = { property_type: ["residential"] };

class ExpiredListingsSearchTable extends PureComponent {

	defaultUnitStage = ["all"];
	defaultStage = this.props.match && this.props.match.params.stage ? [this.props.match.params.stage] : ["all"];

	state = {
		searchMode: syncGenericFilter('search_mode', lsPre, searchModeKey, "off_market") || "off_market",
		order: syncGenericFilter('order', lsPre, 'order', "desc") || "desc",
		orderBy: syncGenericFilter('order_by', lsPre, 'orderBy', "last_listed_sale_expired_date_formatted") || "last_listed_sale_expired_date_formatted",
		selected: new Map([]),
		page: 0,
		rowsPerPage: 50,
		fetchInProgress: false,
		clearInput: false,
		end: 30,
		filterBorough: "all_boroughs",
		searchText: syncURLSearch(this.props, 'searchText'),
		inventoryData: false,
		originalData: false,
		reactTableFiltered: [],
		start: 0,
		stats: {},
		subFilters: syncURLFilters(this.props, _expiredListingsFilters, subFilterKey, lsPre, defaultSubFilter),
		tableData: false,
		totalCount: 0,
		groupedView: false,
		groupedData: false,
		groupedCount: false,
		buildingKey: false,
		unitListData: false,
		unitStages: syncStageFilters(this.props, _unitStageFilter, unitStagesKey, lsPre, this.defaultUnitStage),
		buildingStages: syncStageFilters(this.props, _buildingStageFilter, buildingStagesKey, lsPre, this.defaultStage),
		selectedUnitsAll: {},
		bulkSkipTraceOpen: false,
		saveAlertOpen: false,
	};

	defaultQ = `*:*`;
	defaultBuidingQ = getCohortQuery(this.props.user, true);
	autocompleteFQ = this.defaultBuidingQ;

	_buildingFilter = _expiredListingsFilters.filter(filter => filter.filter_type && filter.filter_type === 'building');

	q = '';
	sort = '';
	unitFq = null;
	fl = expiredListingsFL;

	_getActiveFilters = () => {
		return this.state.searchMode === "on_market" ? _onMarketListingsFilters : _expiredListingsFilters;
	}

	_getPropertyFilter = () => {
		return this._getActiveFilters().filter(filter => !filter.filter_type);
	}

	_getBaseFQ = () => getExpiredListingsBaseFQ(this.state.searchMode)

	componentDidMount() {
		this._getInventoryUnits();
	}

	_setSearchMode = (mode) => {
		if (mode === this.state.searchMode) return;

		const newOrderBy = mode === "on_market"
			? "last_listed_sale_date_all"
			: "last_listed_sale_expired_date_formatted";

		this.setState({
			searchMode: mode,
			subFilters: Object.assign({}, defaultSubFilter),
			orderBy: newOrderBy,
			order: mode === "on_market" ? "asc" : "desc",
			page: 0,
			start: 0,
		});

		setLocalStorage(lsPre, searchModeKey, mode);
		setLocalStorage(lsPre, subFilterKey, JSON.stringify(defaultSubFilter));
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		let searchTagsChange = !_isEqual(prevProps.searchTags, this.props.searchTags);
		let unitStageChange = !_isEqual(prevState.unitStages, this.state.unitStages);
		let buildingStageChange = !_isEqual(prevState.buildingStages, this.state.buildingStages);

		const activeFilters = this._getActiveFilters();
		let subFilterChanged =
			activeFilters.filter(item => {
				return (
					Array.isArray(item.search_key) ?
						item.search_key.filter(key => this.state.subFilters[key] !== prevState.subFilters[key]).length > 0
						:
						this.state.subFilters[item.search_key] !== prevState.subFilters[item.search_key]
				);
			}).length > 0;

		if (
			this.state.searchMode !== prevState.searchMode ||
			this.state.filterBorough !== prevState.filterBorough ||
			this.state.searchText !== prevState.searchText ||
			this.state.orderBy !== prevState.orderBy ||
			this.state.order !== prevState.order ||
			this.state.page !== prevState.page ||
			this.state.rowsPerPage !== prevState.rowsPerPage ||
			(this.state.buildingKey !== prevState.buildingKey && this.state.buildingKey !== false) ||
			searchTagsChange ||
			subFilterChanged ||
			unitStageChange ||
			buildingStageChange
		) {
			const resetPage = this.state.page === prevState.page || this.state.rowsPerPage !== prevState.rowsPerPage;
			this.defaultBuidingQ = getCohortQuery(this.props.user, true);
			this._getInventoryUnits(resetPage);
		}
	}

	handleRequestSort = (event, property) => {
		const orderBy = property;
		let order = 'desc';
		const { orderBy: stateOrderBy, order: stateOrder } = this.state;

		if (stateOrderBy === property && stateOrder === 'desc') { order = 'asc'; }

		this.setState({ order, orderBy });
	};

	handleSelectAllClick = (event, checked) => {
		if (checked) {
			const { tableData } = this.state;
			const newSelected = new Map();
			tableData.map(n => newSelected.set(n.id, true));
			this.setState({ selected: newSelected });
			return;
		}
		this.setState({ selected: new Map([]) });
	};

	handleClick = (event, id) => {
		event.stopPropagation();
		const { selected } = this.state;
		const newSelected = new Map(selected);
		const value = newSelected.get(id);
		let isActive = true;
		if (value) {
			isActive = false;
		}
		newSelected.set(id, isActive);
		this.setState({ selected: newSelected });
	};

	handleBuildingClick = (event, building) => {
		const buildingURL = _isHouse(building) ? _getBuildingURL(building, 'building_slugs') : _getBuildingURL(building, 'building_slugs') + '/' + _nameToUrl(building.address_2_normalized ? building.address_2_normalized : "property");
		this.props.history.push(buildingURL);
	};

	handleChangePage = (event, page) => {
		this.setState({ page: page, start: page * this.state.rowsPerPage });
	};

	handleChangeRowsPerPage = (event) => {
		this.setState({ rowsPerPage: parseInt(event.target.value) });
	};

	handleDeleteSelected = () => {
		const { tableData } = this.state;
		let copyData = [...tableData];
		const { selected } = this.state;

		for (let i = 0; i < [...selected].filter(el => el[1]).length; i += 1) {
			copyData = copyData.filter(obj => obj.id !== selected[i]);
		}

		this.setState({ tableData: copyData, selected: new Map([]) });
	};

	isSelected = (id) => {
		const { selected } = this.state;
		return !!selected.get(id);
	};

	_getInventoryUnits = async (resetPage) => {
		if (!this.state.fetchInProgress) {
			this.setState(prevState => ({ fetchInProgress: true, tableData: false, reactTableFiltered: false }));
		}

		const { searchTags = [] } = this.props;
		const { orderBy, order, buildingStages, searchMode } = this.state;

		setURLFromState(this.props, this.state);
		this.defaultBuidingQ = getCohortQuery(this.props.user, true);

		const { q, fq, sort, autocompleteFQ } = buildExpiredListingsQuery({
			searchMode,
			subFilters: this.state.subFilters,
			buildingStages,
			searchText: this.state.searchText,
			searchTags,
			orderBy,
			order,
			defaultBuildingQ: this.defaultBuidingQ,
			fl: this.fl
		});
		this.q = q;
		this.unitFq = fq;
		this.sort = sort;
		this.autocompleteFQ = autocompleteFQ;

		let axiosData = {
			url: buildingUrl + "we3-properties?cache=30",
			method: "post",
			query: {
				q: this.q,
				fq: this.unitFq,
				sort: this.sort,
				fl: this.fl,
				rows: this.state.rowsPerPage,
				start: resetPage ? 0 : this.state.start,
				wt: "json",
			}
		};

		let response = await _axiosCall(axiosData)
			.then(res => {
				return res;
			})
			.catch(error => {
				console.log("error: " + error);
			});

		let formattedData = response && response.docs ? response.docs.slice(0) : [];

		// For on-market mode, fetch broker info from search-listings
		if (searchMode === "on_market" && formattedData.length > 0) {
			const listingKeys = formattedData
				.map(d => {
					const val = d.last_listed_sale_key_all;
					return Array.isArray(val) ? val[0] : val;
				})
				.filter(Boolean);

			if (listingKeys.length > 0) {
				const listingAxiosData = {
					url: buildingUrl + "search-listings?cache=30",
					method: "post",
					query: {
						q: "key:(" + listingKeys.map(k => `"${k}"`).join(" OR ") + ")",
						fq: ["deleted:false"],
						fl: ["key", "contacts_json"],
						sort: "solr_updated_date desc",
						wt: "json",
						rows: listingKeys.length
					}
				};

				const listingResponse = await _axiosCall(listingAxiosData).catch(error => {
					console.log("listing broker fetch error: " + error);
				});

				if (listingResponse && listingResponse.docs) {
					const listingMap = {};
					listingResponse.docs.forEach(l => { listingMap[l.key] = l; });
					formattedData.forEach(d => {
						const key = Array.isArray(d.last_listed_sale_key_all)
							? d.last_listed_sale_key_all[0]
							: d.last_listed_sale_key_all;
						if (key && listingMap[key]) {
							d._listingData = listingMap[key];
						}
					});
				}
			}
		}


		// Absentee + LLC Unmasked enrichment
		if (formattedData && formattedData.length > 0) {
			const keyToDocKey = {};
			const allKeys = [];
			formattedData.forEach(d => {
				if (d.key) {
					keyToDocKey[d.key] = d.key;
					allKeys.push(d.key);
				}
				if (d.alternate_keys && Array.isArray(d.alternate_keys)) {
					d.alternate_keys.forEach(ak => {
						keyToDocKey[ak] = d.key;
						allKeys.push(ak);
					});
				}
			});
			if (allKeys.length > 0) {
				const absenteeResponse = await _axiosCall({
					url: buildingUrl + "dof-tax-bills?cache=60",
					method: "post",
					query: {
						q: "absentee_owner:true",
						fq: [`{!terms f=property}${allKeys.join(',')}`],
						fl: "property",
						rows: allKeys.length,
						wt: "json"
					}
				}).catch(() => null);
				if (absenteeResponse && absenteeResponse.docs && absenteeResponse.docs.length > 0) {
					const absenteeSet = new Set(absenteeResponse.docs.map(b => keyToDocKey[b.property] || b.property));
					const oneYearAgo = Math.floor((Date.now() - 365 * 24 * 3600 * 1000) / 1000);
					formattedData = formattedData.map(doc =>
						absenteeSet.has(doc.key) && (!doc.last_sold_date || doc.last_sold_date < oneYearAgo)
							? { ...doc, absentee_owner: true }
							: doc
					);
				}

			}
		}

		this.setState(prevState => ({
			fetchInProgress: false,
			tableData: formattedData,
			reactTableFiltered: formattedData,
			totalCount: response ? response.numFound : 0,
			start: resetPage ? 0 : this.state.start,
			page: resetPage ? 0 : this.state.page,
			selectedUnitsAll: {}
		}));
	}

	_filterTableByInput = (tableData, searchText) => {
		this.setState({ searchText: searchText });
	};

	_setSubFilter = (search_key, search_val) => {
		const subF = Object.assign({}, this.state.subFilters, {
			[search_key]: search_val
		});

		this.setState({
			subFilters: subF,
			start: 0,
			end: this.state.rowPerPage
		});

		setLocalStorage(lsPre, subFilterKey, JSON.stringify(subF));
	}

	_setSubFilters = (subFilters, replace = false) => {
		const subF = replace ? Object.assign({}, subFilters) : Object.assign({}, this.state.subFilters, subFilters);
		this.setState({
			subFilters: subF,
			start: 0,
			end: this.state.rowPerPage
		});

		setLocalStorage(lsPre, subFilterKey, JSON.stringify(subF));
	}

	_setBuildingStage = (stage) => {
		let newStages = this.state.buildingStages.slice();
		const index = newStages.indexOf(stage);
		const indexAll = newStages.indexOf('all');

		if (index >= 0) {
			if (stage === "all") {
				newStages = this.defaultStage;
			} else {
				newStages.splice(index, 1);
			}
		} else {
			if (stage === "all") {
				newStages = ["all"];
			} else {
				if (indexAll >= 0) {
					newStages.splice(indexAll, 1);
				}
				newStages.push(stage);
			}
		}

		if (newStages.length === 0) newStages = ['all'];

		this.setState({
			buildingStages: newStages,
			start: 0,
			end: this.state.rowPerPage
		});
		setLocalStorage(lsPre, buildingStagesKey, JSON.stringify(newStages));
	}

	_setUnitStage = (stage) => {
		let newStages = this.state.unitStages.slice();
		const index = newStages.indexOf(stage);
		const indexAll = newStages.indexOf('all');

		if (index >= 0) {
			if (stage === "all") {
				newStages = this.defaultUnitStage;
			} else {
				newStages.splice(index, 1);
			}
		} else {
			if (stage === "all") {
				newStages = ["all"];
			} else {
				if (indexAll >= 0) {
					newStages.splice(indexAll, 1);
				}
				newStages.push(stage);
			}
		}
		if (newStages.length === 0) newStages = this.defaultUnitStage;
		this.setState({
			unitStages: newStages,
			start: 0,
			end: this.state.rowPerPage
		});
		setLocalStorage(lsPre, unitStagesKey, JSON.stringify(newStages));
	}

	_resetSubFilter = (search_key, search_val) => {
		const subF = Object.assign({}, defaultSubFilter);
		this.setState({
			buildingStages: this.defaultStage,
			unitStages: this.defaultUnitStage,
			subFilters: subF,
			start: 0,
			end: this.state.rowPerPage
		});
		deleteLocalStorage(lsPre, buildingStagesKey);
		deleteLocalStorage(lsPre, unitStagesKey);
		deleteLocalStorage(lsPre, subFilterKey);
	}

	_resetActive = () => {
		const { searchTags } = this.props;
		let isDefault = (!searchTags || searchTags.length === 0) &&
			_objectEqual(defaultSubFilter, this.state.subFilters) &&
			_objectEqual(this.defaultUnitStage, this.state.unitStages) &&
			_objectEqual(this.defaultStage, this.state.buildingStages);

		return !isDefault;
	}

	_setParentSelected = (property) => {
		const { selectedUnitsAll } = this.state;
		const newSelected = Object.assign({}, selectedUnitsAll);
		if(newSelected[property.key]){
			delete newSelected[property.key];
		}else{
			newSelected[property.key] = property;
		}
		this.setState( { selectedUnitsAll: Object.assign({}, newSelected) } );
	}

	_setParentSelectedAll = (selectedUnits, type) => {
		const { selectedUnitsAll } = this.state;
		const newSelected = Object.assign({}, selectedUnitsAll);
		if(type == 'add'){
			selectedUnits.forEach(property => {
				newSelected[property.key] = property;
			})
		}else if(type == 'remove'){
			selectedUnits.forEach(property => {
				delete newSelected[property.key];
			})
		}
		this.setState( { selectedUnitsAll: Object.assign({}, newSelected) } );
	}

	_clearSelectedUnits(){
		this.setState({selectedUnitsAll:{}})
	}

	render() {
		const {
			order, orderBy, selected, rowsPerPage, page, tableData, reactTableFiltered, subFilters, totalCount, fetchInProgress, searchText, unitStages, selectedUnitsAll, buildingStages, searchMode
		} = this.state;
		const { user } = this.props;

		const paginationCount = totalCount;

		const exportFields = user && user.dataExportRestrictions && user.dataExportRestrictions.indexOf('property-fields-restricted') >= 0 ? propertyExportFLRestricted : propertyExportFL;
		const activeFilters = this._getActiveFilters();
		const isOnMarket = searchMode === "on_market";

		const selectedKeys = Object.keys(selectedUnitsAll);
		const hasSelection = selectedKeys.length > 0;
		const exportQ = hasSelection ? `key:(${selectedKeys.map(k => `"${k}"`).join(' ')})` : this.q;
		const exportFq = hasSelection ? ['deleted:false'] : this.unitFq;
		const exportCount = hasSelection ? selectedKeys.length : totalCount;

		return (
			<Col md={12} lg={12}>
				<Card>
					<CardBody style={{ padding: 0 }} className="unit_search">
						{!isMobile && <Fragment>
							{_hasPermission(user, 'skip-trace') && <div style={{ position: 'fixed', bottom: 90, right: 360, zIndex: 999 }}>
								<Tooltip title={hasSelection ? `Export contact info for ${selectedKeys.length} selected` : "Export contact info (email & phone) for owners"}>
									<Fab
										variant="extended"
										size="medium"
										aria-label="export-contact-info"
										style={{ fontWeight: 400, background: (!exportCount || fetchInProgress) ? '#DBE0E8' : '#780F9E', color: (!exportCount || fetchInProgress) ? '#F5F7FA' : '#fff', width: 240 }}
										onClick={() => this.setState({ bulkSkipTraceOpen: true })}
										disabled={!exportCount || fetchInProgress}
									>
										<ContactPhoneIcon style={{ marginRight: 5 }} /> Export Contact Info
									</Fab>
								</Tooltip>
							</div>}
							<OwnerListButton
								q={exportQ}
								fq={exportFq}
								fl={mailingListFL}
								sort={this.sort}
								core_name={'we3-properties'}
								export_name={isOnMarket ? `My Aging Listings List` : `My Expired Listings List`}
								title={'Export Owner List'}
								description={<Fragment><h4><strong>Confirm Owner List</strong></h4> <br/> The export will include mailing address and owner name.{hasSelection && <span><br/><strong>{selectedKeys.length} properties selected</strong> — only selected properties will be exported.</span>}</Fragment>}
								exportCount={exportCount}
								floatButton={true}
								fetchInProgress={fetchInProgress}
							/>
						</Fragment>}
						{this.state.bulkSkipTraceOpen && <BulkSkipTraceModal
							isOpen={this.state.bulkSkipTraceOpen}
							onClose={() => this.setState({ bulkSkipTraceOpen: false })}
							coreName={'we3-properties'}
							totalCount={exportCount}
							queryOptions={{
								q: exportQ,
								fq: exportFq,
								fl: mailingListFL,
								sort: this.sort
							}}
						/>}
						<SaveAlertModal
							open={this.state.saveAlertOpen}
							onClose={() => this.setState({ saveAlertOpen: false })}
							user={user}
							subFilters={subFilters}
							buildingStages={this.state.buildingStages}
							searchText={searchText}
							searchTags={this.props.searchTags || []}
							orderBy={this.state.orderBy}
							order={this.state.order}
						/>
						<BuildingSearchAppBar
							handleSearch={this._filterTableByInput}
							numSelected={[...selected].filter(el => el[1]).length}
							handleDeleteSelected={this.handleDeleteSelected}
							onRequestSort={this.handleRequestSort}
							subFilters={subFilters}
							searchText={searchText}
							setSubFilter={this._setSubFilter}
							resetSubFilter={this._resetSubFilter}
							_filters={(user && user.role && user.role.indexOf('admin') >= 0) ? activeFilters : activeFilters.filter(item => !item.admin_only)}
							{...this.props}
							groupedView
							building={null}
							placeHolder={'Building, Neighborhood or Borough'}
							unitStages={unitStages}
							setUnitStage={this._setUnitStage}
							buildingStages={this.state.buildingStages}
							setBuildingStage={this._setBuildingStage}
							buildingAttributes={[]}
							goToBuilding={false}
							numToShow={7}
							setSubFilters={this._setSubFilters}
							buildingTab={'units'}
							resetActive={this._resetActive()}
							showExport={false}
							extraActions={!isOnMarket && (
								<Tooltip title={fetchInProgress ? 'Loading results…' : 'Save this search and email me daily'}>
									<span>
										<Button
											onClick={() => this.setState({ saveAlertOpen: true })}
											variant="outlined"
											disabled={fetchInProgress}
											startIcon={<BellPlusIcon size={20} />}
											style={{
												textTransform: 'none',
												borderColor: '#fff',
												borderWidth: 1.5,
												color: '#fff',
												fontWeight: 600,
												fontSize: 14,
												padding: '8px 18px',
												marginRight: 8,
												opacity: fetchInProgress ? 0.5 : 1
											}}
										>
											Save Search Alert
										</Button>
									</span>
								</Tooltip>
							)}
							q={this.q}
							fq={this.unitFq}
							fl={exportFields}
							sort={this.sort}
							totalCount={totalCount}
							belowStageContent={
								<div className="tabs" style={{ marginTop: 10, marginBottom: 0 }}>
									<div className="tabs__wrap">
										<Nav tabs>
											<NavItem>
												<NavLink
													className={classnames({ active: !isOnMarket })}
													onClick={() => this._setSearchMode("off_market")}
												>
													<span className="tab-title">Recently Off Market</span>
												</NavLink>
											</NavItem>
											<NavItem>
												<NavLink
													className={classnames({ active: isOnMarket })}
													onClick={() => this._setSearchMode("on_market")}
												>
													<span className="tab-title">Aging Listings</span>
												</NavLink>
											</NavItem>
										</Nav>
									</div>
								</div>
							}
						/>
						<ToggleChips chipData={isOnMarket ? onMarketChipData : expiredListingsChipData} setSubFilters={this._setSubFilters} subFilters={subFilters} />
						<div className="material-table__header-info unit_search">
							<Row>
								<Col md={12} lg={12}>
									<div className={`count_toggle`}>
										<div>
											<span className="bold-text">{totalCount > 0 ? _formatNumber(totalCount) : '--'}</span>{` `}{isOnMarket ? "Aging Listings" : "Expired Listings"}
										</div>
									</div>
								</Col>
							</Row>
						</div>

						{hasSelection &&
							<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 16px', background: '#F3E8FF', borderBottom: '1px solid #D6BAE8' }}>
								<span style={{ fontSize: 13, color: '#4A154B', fontWeight: 500 }}>
									<span className="bold-text">{selectedKeys.length}</span> {selectedKeys.length === 1 ? 'property' : 'properties'} selected — exports will use selected properties only
								</span>
								<Button
									onClick={() => this._clearSelectedUnits()}
									size="small"
									style={{ fontSize: 12, color: '#780F9E', textTransform: 'none' }}
								>
									Clear Selection
								</Button>
							</div>
						}
						<div className="material-table__wrap">
							{fetchInProgress && <LinearLoading />}
							{tableData &&
								<ExpiredListingsListTable
									isGrouped={false}
									handleRequestSort={this.handleRequestSort}
									handleSelectAllClick={this.handleSelectAllClick}
									handleBuildingClick={this.handleBuildingClick}
									handleClick={this.handleClick}
									isSelected={this.isSelected}
									tableData={tableData}
									order={order}
									orderBy={orderBy}
									selected={selected}
									building={null}
									fl={this.fl}
									q={this.q}
									fq={this.unitFq}
									user={user}
									subFilters={subFilters}
									selectedUnitsAll={selectedUnitsAll}
									handleSelectParent={this._setParentSelected.bind(this)}
									handleSelectParentAll={this._setParentSelectedAll.bind(this)}
									searchMode={searchMode}
								/>
							}
						</div>
						{totalCount ? <TablePagination
							component="div"
							className="material-table__pagination"
							count={paginationCount}
							rowsPerPage={rowsPerPage}
							page={page}
							backIconButtonProps={{ 'aria-label': 'Previous Page' }}
							nextIconButtonProps={{ 'aria-label': 'Next Page' }}
							onChangePage={this.handleChangePage}
							onChangeRowsPerPage={this.handleChangeRowsPerPage}
							rowsPerPageOptions={[25, 50, 100]}
							dir="ltr"
							SelectProps={{
								inputProps: { 'aria-label': 'rows per page' },
								native: true,
							}}
						/> : null}
					</CardBody>
				</Card>
			</Col>
		);
	}
}

export default connect(state => ({
	user: state.user,
	searchTags: Array.isArray(state.search.searchTags) ? state.search.searchTags.slice() : []
}))(withRouter(ExpiredListingsSearchTable));
